import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import { ReactComponent as RightArrow } from '../../../assets/icons/svg/shared/ic-shared-right-arrow.svg';

interface IProps {
  onDisconnectClick: () => void;
  isLoading: boolean;
}

const GustoConnected = ({ onDisconnectClick, isLoading }: IProps) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid='GustoApp__card-status-connected'
      className='w-[552px] h-[249px] bg-bw00 rounded-[8px] px-[40px] pt-[33px] pb-[34px] flex flex-col justify-between shadow-widgetCard'
    >
      <div>
        <Heading.H7 fontWeight={FontWeight.MEDIUM}>{t('GUSTO.CONNECTED.TITLE')}</Heading.H7>
        <Text.H9 className='mt-[9px] mb-[28px]'>{t('GUSTO.CONNECTED.SUBTITLE')}</Text.H9>
      </div>
      <div>
        <div
          data-testid='GustoApp__disconnect-btn'
          onClick={() => !isLoading && onDisconnectClick()}
          role='button'
          onKeyDown={() => {}}
          tabIndex={0}
          className='flex items-center hover:cursor-pointer'
        >
          <div className='font-metricR text-sm text-text-brand-primary'>{t('GUSTO.DISCONNECT')}</div>
          <RightArrow className='w-[14px] h-[14px] text-text-brand-primary' />
        </div>
      </div>
    </div>
  );
};

export default GustoConnected;
